export const listProducts = `
   query listProducts($filter: ProductsFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listProducts(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              name
              shortDescription
              longDescription
              productImage
              status
              lineItems {
                items {
                  id
                  productFeature {
                    id
                    name
                  }
                }
                nextToken
              }
              billingProviderId
              billingProviderRecordId
              freeTrial
              createdByUsername
              created
              updated
           }
           nextToken
       }
   }
`;

export const getProduct = `
   query getProduct($id:ID!) {
       getProduct(id:$id) {
          id
          name
          shortDescription
          longDescription
          productImage
          status
          lineItems {
            items {
              id
              productFeature {
                id
                name
              }
            }
            nextToken
          }
          billingProviderId
          billingProviderRecordId
          freeTrial
          createdByUsername
          createdByUser {
            name
            givenName
            familyName
            email
          }
          created
          updated
       } 
}`;
